export default "__VITE_ASSET__CuYLnGX6__"